import React from 'react'
import {Alert} from "reactstrap";

const NotInfoComponent = ({handleCalculateMetrics}) => <Alert color={'primary'} className={'no-info'}>
    <span>No se encontró información. Es necesario <span className={'text-clickable'} onClick={()=>handleCalculateMetrics()}>generar</span> la información. </span>
</Alert>

export default NotInfoComponent